import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useFormContext } from 'react-hook-form';
import { Button } from 'shared/mui/Buttons';

type Props = {
  onReset: VoidFunction;
};

export const OrderAdjustmentsGroupCommentResetButton = ({ onReset }: Props) => {
  const translate = useTypedTranslate();
  const { setValue } = useFormContext();

  return (
    <Button
      label={translate('app.orderAdjustments.dialogs.groupCommentDialog.buttons.reset')}
      onClick={() => {
        setValue('comment', '');
        onReset();
      }}
      type="button"
      variant="outlined"
    />
  );
};
